var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/RichText/ErrorComponent.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
function ErrorComponent({
  children
}) {
  return /* @__PURE__ */ jsx5("div", { style: {
    border: "1px dotted red",
    color: "red"
  }, children });
}
var init_ErrorComponent = __esm({
  "src/RichText/ErrorComponent.tsx"() {
  }
});

// src/RichText/ErrorBoundary/ErrorBoundaryServer.tsx
var ErrorBoundaryServer_exports = {};
__export(ErrorBoundaryServer_exports, {
  ErrorBoundaryServer: () => ErrorBoundaryServer
});
import { Fragment, jsx as jsx6 } from "react/jsx-runtime";
function ErrorBoundaryServer({ children }) {
  return /* @__PURE__ */ jsx6(Fragment, { children });
}
var init_ErrorBoundaryServer = __esm({
  "src/RichText/ErrorBoundary/ErrorBoundaryServer.tsx"() {
  }
});

// src/RichText/ErrorBoundary/ErrorBoundaryClient.tsx
var ErrorBoundaryClient_exports = {};
__export(ErrorBoundaryClient_exports, {
  ErrorBoundaryClient: () => ErrorBoundaryClient
});
import { Component } from "react";
import { jsx as jsx7 } from "react/jsx-runtime";
function ErrorBoundaryClient({ children }) {
  return /* @__PURE__ */ jsx7(ErrorBoundary, { Fallback: ({ error }) => /* @__PURE__ */ jsx7(ErrorComponent, { children: error.message }), children });
}
var ErrorBoundary;
var init_ErrorBoundaryClient = __esm({
  "src/RichText/ErrorBoundary/ErrorBoundaryClient.tsx"() {
    "use client";
    init_ErrorComponent();
    ErrorBoundary = class extends Component {
      constructor(props) {
        super(props);
        this.state = { hasError: false, error: new Error() };
      }
      static getDerivedStateFromError(error) {
        return { hasError: true };
      }
      componentDidCatch(error, _errorInfo) {
        this.setState({ error });
      }
      render() {
        if (this.state.hasError) {
          return /* @__PURE__ */ jsx7(this.props.Fallback, { error: this.state.error });
        }
        return this.props.children;
      }
    };
  }
});

// src/Layout.tsx
import PropTypes3 from "prop-types";

// src/Regions.tsx
import PropTypes2 from "prop-types";

// src/Region.tsx
import PropTypes from "prop-types";

// src/ComponentTag.ts
var ComponentTag_default = (component) => component && component.path ? `						
							<!--# COMPONENT ${component.path} -->` : null;

// src/Region.tsx
import { jsx } from "react/jsx-runtime";
var Region = ({
  name,
  regionData,
  tag,
  addClass
}) => {
  if (!(name || "").trim()) {
    console.error(`<Region NO_NAME> name: ${JSON.stringify(name)}`);
    throw Error(`Can't render <Region> without a 'name' prop.`);
  }
  if (!regionData || typeof regionData !== "object" || !Object.keys(regionData).length) {
    console.error(`<Region "${name}"> regionData: ${JSON.stringify(regionData)}`);
    throw Error(`Can't render <Region "${name}"> without a 'regionData' prop.`);
  }
  const TAG = tag || "div";
  return /* @__PURE__ */ jsx(
    TAG,
    {
      "data-portal-region": name,
      className: "xp-region" + (addClass ? ` ${addClass}` : ""),
      dangerouslySetInnerHTML: {
        __html: `					${regionData.components && regionData.components.length > 0 ? regionData.components.map((component) => ComponentTag_default(component)).join("\n") : ""}					
`
      }
    }
  );
};
Region.propTypes = {
  name: PropTypes.string.isRequired,
  regionData: PropTypes.shape({
    components: PropTypes.arrayOf(PropTypes.shape({
      path: PropTypes.string.isRequired
    }))
  }).isRequired,
  tag: PropTypes.string,
  addClass: PropTypes.string
};
var Region_default = Region;

// src/Regions.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var Regions = ({
  regionsData,
  names,
  tags,
  classes
}) => {
  if (!regionsData || typeof regionsData !== "object") {
    console.error("<Regions> regions: " + JSON.stringify(regionsData));
    throw Error("Can't render <Regions> without a 'regionsData' prop.");
  }
  const selectedRegions = !names ? Object.keys(regionsData) : typeof names === "string" ? [names] : Array.isArray(names) ? names : null;
  if (!selectedRegions) {
    console.error("<Regions> names: " + JSON.stringify(names));
    throw Error("Can't render <Regions>: 'names' prop must be a string, an array of strings or omitted/falsy.");
  }
  return selectedRegions.map(
    (name) => (
      //@ts-ignore
      /* @__PURE__ */ jsx2(
        Region_default,
        {
          regionData: regionsData[name],
          name,
          tag: typeof tags === "string" ? tags : (tags || {})[name],
          addClass: classes === true ? name : typeof classes === "string" ? classes : (classes || {})[name]
        },
        name
      )
    )
  );
};
Regions.propTypes = {
  regionsData: PropTypes2.objectOf(
    PropTypes2.shape({
      components: PropTypes2.arrayOf(
        PropTypes2.shape({
          path: PropTypes2.string.isRequired
        })
      )
    })
  ).isRequired,
  names: PropTypes2.oneOfType([
    PropTypes2.string,
    PropTypes2.arrayOf(
      PropTypes2.string
    )
  ]),
  tags: PropTypes2.oneOfType([
    PropTypes2.string,
    PropTypes2.objectOf(
      PropTypes2.string
    )
  ]),
  classes: PropTypes2.oneOfType([
    PropTypes2.bool,
    PropTypes2.string,
    PropTypes2.objectOf(
      PropTypes2.string
    )
  ])
};
var Regions_default = Regions;

// src/Layout.tsx
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
var Layout = ({
  regionsData,
  regionNames,
  regionClasses,
  containerTag,
  containerClass,
  children,
  childrenAfterRegions
}) => {
  const TAG = containerTag || "div";
  return /* @__PURE__ */ jsxs(TAG, { className: containerClass, children: [
    !childrenAfterRegions ? children : null,
    regionsData ? /* @__PURE__ */ jsx3(Regions_default, { regionsData, classes: regionClasses, names: regionNames }) : null,
    childrenAfterRegions ? children : null
  ] });
};
Layout.propTypes = {
  regionsData: PropTypes3.objectOf(
    PropTypes3.shape({
      components: PropTypes3.arrayOf(
        PropTypes3.shape({
          path: PropTypes3.string.isRequired
        })
      )
    })
  ),
  regionNames: PropTypes3.oneOfType([
    PropTypes3.string,
    PropTypes3.arrayOf(PropTypes3.string)
  ]),
  regionClasses: PropTypes3.oneOfType([
    PropTypes3.bool,
    PropTypes3.string,
    PropTypes3.objectOf(PropTypes3.string)
  ]),
  containerTag: PropTypes3.string,
  containerClass: PropTypes3.string,
  childrenAfterRegions: PropTypes3.bool
};
var Layout_default = Layout;

// src/Page.tsx
import PropTypes4 from "prop-types";
import { jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var Page = ({
  title,
  regionsData,
  regionNames,
  regionClasses,
  children,
  childrenAfterRegions
}) => {
  return [
    /* @__PURE__ */ jsx4("head", { children: title ? /* @__PURE__ */ jsx4("title", { children: title }) : null }),
    /* @__PURE__ */ jsxs2("body", { className: "xp-page", children: [
      !childrenAfterRegions ? children : null,
      regionsData ? /* @__PURE__ */ jsx4(Regions_default, { regionsData, classes: regionClasses, names: regionNames }) : null,
      childrenAfterRegions ? children : null
    ] })
  ];
};
Page.propTypes = {
  title: PropTypes4.string,
  regionsData: PropTypes4.objectOf(
    PropTypes4.shape({
      components: PropTypes4.arrayOf(
        PropTypes4.shape({
          path: PropTypes4.string.isRequired
        })
      )
    })
  ),
  regionNames: PropTypes4.oneOfType([
    PropTypes4.string,
    PropTypes4.arrayOf(PropTypes4.string)
  ]),
  regionClasses: PropTypes4.oneOfType([
    PropTypes4.bool,
    PropTypes4.string,
    PropTypes4.objectOf(PropTypes4.string)
  ]),
  childrenAfterRegions: PropTypes4.bool
};
var Page_default = Page;

// src/RichText.tsx
import * as parser from "html-react-parser";

// src/RichText/createReplacer.ts
import { ElementType } from "domelementtype";

// src/constants.ts
var IMG_TAG = "img";
var LINK_TAG = "a";
var MACRO_TAG = "editor-macro";
var IMG_ATTR = "data-image-ref";
var LINK_ATTR = "data-link-ref";
var MACRO_ATTR = "data-macro-ref";

// src/RichText/cssToReactStyle.ts
function cssToReactStyle(cssString) {
  if (!cssString) {
    return {};
  }
  const styleObject = {};
  const rules = cssString.split(";");
  rules.forEach((rule) => {
    const [key, value] = rule.trim().split(":");
    if (key && value) {
      styleObject[key.replace(/-([a-z])/g, (_match, group1) => group1.toUpperCase())] = value;
    }
  });
  return styleObject;
}

// src/RichText/replaceImage.tsx
init_ErrorComponent();

// src/RichText/ErrorBoundary/ErrorBoundaryWrapper.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
function ErrorBoundaryWrapper({ children }) {
  if (typeof window === "undefined") {
    const { ErrorBoundaryServer: ErrorBoundaryServer2 } = (init_ErrorBoundaryServer(), __toCommonJS(ErrorBoundaryServer_exports));
    return /* @__PURE__ */ jsx8(ErrorBoundaryServer2, { children });
  } else {
    const { ErrorBoundaryClient: ErrorBoundaryClient2 } = (init_ErrorBoundaryClient(), __toCommonJS(ErrorBoundaryClient_exports));
    return /* @__PURE__ */ jsx8(ErrorBoundaryClient2, { children });
  }
}

// src/RichText/replaceImage.tsx
import { jsx as jsx9, jsxs as jsxs3 } from "react/jsx-runtime";
function replaceImage(_a) {
  var _b = _a, {
    el,
    Image: Image2,
    images
  } = _b, rest = __objRest(_b, [
    "el",
    "Image",
    "images"
  ]);
  if (!images || !images.length) {
    return /* @__PURE__ */ jsx9(ErrorComponent, { children: "Can't replace image, when there are no images in the data object!" });
  }
  const imageRef = el.attribs[IMG_ATTR];
  if (!imageRef) {
    return /* @__PURE__ */ jsx9(ErrorComponent, { children: "Image element has no data-image-ref attibute!" });
  }
  const imageData = images.find((data) => data.ref === imageRef);
  if (!imageData) {
    return /* @__PURE__ */ jsxs3(ErrorComponent, { children: [
      "Unable to find image with ref ",
      imageRef,
      " in images object!"
    ] });
  }
  const {
    attribs: {
      alt,
      sizes,
      src,
      srcset: srcSet,
      style: styleStr = ""
    }
  } = el;
  const style = cssToReactStyle(styleStr);
  const {
    image,
    style: imageStyle
  } = imageData;
  const imgProps = __spreadProps(__spreadValues({}, rest), { alt, image, imageStyle, sizes, src, srcSet, style });
  return /* @__PURE__ */ jsx9(ErrorBoundaryWrapper, { children: /* @__PURE__ */ jsx9(Image2, __spreadValues({}, imgProps)) });
}

// src/RichText/replaceLink.tsx
import { domToReact } from "html-react-parser";
init_ErrorComponent();
import { jsx as jsx10, jsxs as jsxs4 } from "react/jsx-runtime";
function replaceLink(_a) {
  var _b = _a, {
    createReplacer: createReplacer2,
    data,
    el,
    Image: Image2,
    Link: Link2,
    Macro: Macro2,
    replacer
  } = _b, rest = __objRest(_b, [
    "createReplacer",
    "data",
    "el",
    "Image",
    "Link",
    "Macro",
    "replacer"
  ]);
  const {
    attribs: {
      href,
      [LINK_ATTR]: linkRef,
      target,
      title
    }
  } = el;
  if (!linkRef) {
    return;
  }
  if (!href) {
    return /* @__PURE__ */ jsx10(ErrorComponent, { children: "Link element has no href attribute!" });
  }
  const {
    links
  } = data;
  if (!links || !links.length) {
    return /* @__PURE__ */ jsx10(ErrorComponent, { children: "Can't replace link, when there are no links in the data object!" });
  }
  const linkData = links.find((data2) => data2.ref === linkRef);
  if (!linkData) {
    return /* @__PURE__ */ jsxs4(ErrorComponent, { children: [
      "Unable to find link with ref ",
      linkRef,
      " in links object!"
    ] });
  }
  const {
    content,
    media,
    uri
  } = linkData;
  const linkProps = __spreadProps(__spreadValues({}, rest), { content, href, media, target, title, uri });
  const children = domToReact(el.children, {
    replace: createReplacer2(__spreadProps(__spreadValues({}, rest), {
      // These should be last, so they can't be overridden
      data,
      Image: Image2,
      Link: Link2,
      Macro: Macro2,
      replacer
    }))
  });
  return /* @__PURE__ */ jsx10(ErrorBoundaryWrapper, { children: /* @__PURE__ */ jsx10(Link2, __spreadProps(__spreadValues({}, linkProps), { children })) });
}

// src/RichText/replaceMacro.tsx
init_ErrorComponent();
import { domToReact as domToReact2 } from "html-react-parser";

// src/utils/sanitizeGraphqlName.ts
var sanitizeGraphqlName = (text) => {
  if (!text || text.trim().length === 0) {
    return "";
  }
  let result = text.replace(/([^0-9A-Za-z])+/g, "_");
  if (result.length > 0 && /[0-9]/.test(result.charAt(0))) {
    result = "_" + result;
  }
  return result;
};

// src/RichText/replaceMacro.tsx
import { jsx as jsx11, jsxs as jsxs5 } from "react/jsx-runtime";
function replaceMacro(_a) {
  var _b = _a, {
    createReplacer: createReplacer2,
    data,
    el,
    Image: Image2,
    Link: Link2,
    Macro: Macro2,
    replacer
  } = _b, rest = __objRest(_b, [
    "createReplacer",
    "data",
    "el",
    "Image",
    "Link",
    "Macro",
    "replacer"
  ]);
  const ref = el.attribs[MACRO_ATTR];
  if (!ref) {
    return /* @__PURE__ */ jsx11(ErrorComponent, { children: "Macro element has no data-macro-ref attribute!" });
  }
  const {
    macros
  } = data;
  if (!macros || !macros.length) {
    return /* @__PURE__ */ jsx11(ErrorComponent, { children: "Can't replace macro, when there are no macros in the data object!" });
  }
  const macroData = macros.find((d) => d.ref === ref);
  if (!macroData) {
    return /* @__PURE__ */ jsxs5(ErrorComponent, { children: [
      "Unable to find macro with ref ",
      ref,
      " in macros object!"
    ] });
  }
  const { descriptor, name, config: configs } = macroData;
  const config = configs[sanitizeGraphqlName(name)];
  const props = __spreadProps(__spreadValues({}, rest), { config, descriptor });
  const children = domToReact2(el.children, {
    replace: createReplacer2(__spreadProps(__spreadValues({}, rest), {
      // These should be last, so they can't be overridden
      data,
      Image: Image2,
      Link: Link2,
      Macro: Macro2,
      replacer
    }))
  });
  return /* @__PURE__ */ jsx11(ErrorBoundaryWrapper, { children: /* @__PURE__ */ jsx11(Macro2, __spreadProps(__spreadValues({}, props), { children })) });
}

// src/RichText/createReplacer.ts
function createReplacer(_a) {
  var _b = _a, {
    data,
    Image: Image2,
    Link: Link2,
    Macro: Macro2,
    replacer
  } = _b, rest = __objRest(_b, [
    "data",
    "Image",
    "Link",
    "Macro",
    "replacer"
  ]);
  const {
    images
  } = data;
  return (domNode) => {
    if (domNode.type !== ElementType.Tag) {
      return domNode;
    }
    const el = domNode;
    switch (el.tagName) {
      case IMG_TAG:
        return replaceImage(__spreadProps(__spreadValues({}, rest), {
          el,
          Image: Image2,
          images
        }));
      case LINK_TAG:
        return replaceLink(__spreadProps(__spreadValues({}, rest), {
          // These should be last, so they can't be overridden
          createReplacer,
          data,
          el,
          Image: Image2,
          Link: Link2,
          Macro: Macro2,
          replacer
        }));
      case MACRO_TAG:
        return replaceMacro(__spreadProps(__spreadValues({}, rest), {
          // These should be last, so they can't be overridden
          createReplacer,
          data,
          el,
          Image: Image2,
          Link: Link2,
          Macro: Macro2,
          replacer
        }));
      default:
        if (replacer) {
          const result = replacer(
            el,
            data
          );
          if (result) {
            return result;
          }
        }
    }
    return el;
  };
}

// src/RichText/Image.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var Image = ({
  alt,
  // image,
  // imageStyle,
  sizes,
  src,
  srcSet,
  style
}) => {
  const imgProps = { alt, sizes, src, srcSet, style };
  return /* @__PURE__ */ jsx12("img", __spreadValues({}, imgProps));
};

// src/RichText/Link.tsx
import { jsx as jsx13 } from "react/jsx-runtime";
var Link = (_a) => {
  var _b = _a, {
    content: _content,
    media: _media,
    uri: _uri
  } = _b, aProps = __objRest(_b, [
    // children, // in aProps
    "content",
    "media",
    // href, // in aProps
    // target, // in aProps
    // title, // in aProps
    "uri"
  ]);
  return /* @__PURE__ */ jsx13("a", __spreadValues({}, aProps));
};

// src/RichText/Macro.tsx
import { jsxs as jsxs6 } from "react/jsx-runtime";
function Macro({
  config,
  descriptor
}) {
  return /* @__PURE__ */ jsxs6("div", { style: {
    border: "1px dotted orange",
    color: "orange"
  }, children: [
    "No Macro component provided to RichText. Can't render ",
    descriptor,
    " with config ",
    JSON.stringify(config, null, 4)
  ] });
}

// src/RichText.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
function RichText(_a) {
  var _b = _a, {
    className,
    data,
    Image: Image2 = Image,
    Link: Link2 = Link,
    Macro: Macro2 = Macro,
    replacer,
    tag
  } = _b, rest = __objRest(_b, [
    "className",
    "data",
    "Image",
    "Link",
    "Macro",
    "replacer",
    "tag"
  ]);
  const CustomTag = tag || "section";
  return /* @__PURE__ */ jsx14(CustomTag, { className, children: data.processedHtml ? (parser.default.default || parser.default)(data.processedHtml, {
    replace: createReplacer(__spreadProps(__spreadValues({}, rest), {
      // These should be last, so they can't be overridden
      data,
      Image: Image2,
      Link: Link2,
      Macro: Macro2,
      replacer
    }))
  }) : "" });
}
export {
  ComponentTag_default as ComponentTag,
  Layout_default as Layout,
  Page_default as Page,
  Region_default as Region,
  Regions_default as Regions,
  RichText,
  cssToReactStyle,
  sanitizeGraphqlName
};
